<main class="main-container" id="main" [class.page-background]="pageNumber === 4">
    <div class="content">
        <div class="container">
            <app-progress-tracker [steps]="steps" [currentStep]="pageNumber - 1" (stepClick)="selectPage($event)">
            </app-progress-tracker>
            <section class="section-container">
                <div [hidden]="pageNumber != 1">
                    <app-urban-planner-information (pageNumberEvent)="changePage($event)"
                        (formSubmittedEvent)="onFormSubmitted()">
                    </app-urban-planner-information>
                </div>
                <div [hidden]="pageNumber != 2">
                    <app-urban-planner-extended-network (pageNumberEvent)="changePage($event)"
                        (formSubmittedEvent)="onFormSubmitted()">
                    </app-urban-planner-extended-network>
                </div>
                <div [hidden]="pageNumber != 3">
                    <app-urban-planner-submit-documents (pageNumberEvent)="changePage($event)"
                        (formSubmittedEvent)="onFormSubmitted()" (documentsSubmitted)="onDocumentSubmitted()">
                    </app-urban-planner-submit-documents>
                </div>
                <div [hidden]="pageNumber != 4">
                    <app-urban-planner-sign-contract></app-urban-planner-sign-contract>
                </div>
            </section>
        </div>
    </div>
</main>